<p-dialog
  [className]="'eccc'"
  [closable]="false"
  [header]="inputData.title | translate"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '800px'}"
  [minY]="500"
  [maximizable]="false"
  [autoZIndex]="false">

  <div class="container">
    <app-table-view
      [data]="inputData.summary"
      [config]="tableConfig"
    >
    </app-table-view>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <div class="float-right">
        <button type="button" class="btn btn-secondary mr-2" (click)="close()">
          {{'COMMON.actionsLabel.CLOSE' | translate}}
        </button>
        <button type="button" class="btn btn-primary mr-2" (click)="save()">
          {{'COMMON.actionsLabel.SAVE' | translate}}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
